/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const BrandGo: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 24 24" size={size} color={color} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.07 15.115c-1.865 0-3.272-1.434-3.272-3.336 0-1.903 1.407-3.337 3.272-3.337 1.865 0 3.271 1.434 3.271 3.337 0 1.902-1.406 3.336-3.271 3.336zm0-9.111c-3.852 0-5.93 2.975-5.93 5.775 0 2.799 2.078 5.773 5.93 5.773S24 14.578 24 11.78c0-2.8-2.078-5.775-5.93-5.775zM11.644 10.697H5.949a.135.135 0 00-.135.135v2.096c0 .075.06.135.135.135h3.012c-.49 1.25-1.66 2.048-3.032 2.048-1.865 0-3.271-1.435-3.271-3.337 0-1.902 1.406-3.336 3.271-3.336 1.148 0 2.15.542 2.746 1.486a.135.135 0 00.21.025l1.678-1.653a.136.136 0 00.01-.181C9.487 6.75 7.837 6 5.93 6 2.078 6 0 8.975 0 11.774c0 2.8 2.078 5.775 5.93 5.775 3.85 0 5.93-2.976 5.93-5.775 0-.316-.028-.64-.083-.964a.136.136 0 00-.133-.114z"
        fill="#A5C83D"
      />
    </Icon>
  );
};

export default BrandGo;

BrandGo.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
